import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export enum SendGiftReceiptErrorCode {
  UNAUTHORIZED = "UNAUTHORIZED",
  NOT_FOUND = "NOT_FOUND",
  SEND_FAILED = "SEND_FAILED",
}

export const sendGiftReceipt = {
  name: "sendGiftReceipt" as const,
  input: z.object({ giftReceiptId: zExt.objectId(), email: z.string() }),
  output: z.object({ success: z.boolean() }),
};
